import { motion } from "framer-motion";
import { Icon } from "@iconify/react";

export default function CTASection() {
    return (
        <section className="relative py-20 lg:py-28 bg-linear-to-br from-slate-900 via-blue-950 to-slate-900 overflow-hidden">
            {/* Background decorations */}
            <div className="absolute inset-0">
                <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl" />
                <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-blue-500/10 rounded-full blur-3xl" />
            </div>

            <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <div className="inline-flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full mb-8">
                        <Icon icon="mdi:rocket-launch-outline" width={20} className="text-blue-400" />
                        <span className="text-sm text-white/70 font-medium">
                            Começa hoje mesmo
                        </span>
                    </div>

                    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
                        Pronto para transformar a gestão{" "}
                        <span className="bg-linear-to-r from-blue-400 to-blue-300 bg-clip-text text-transparent">
                            da tua empresa?
                        </span>
                    </h2>

                    <p className="text-lg text-white/50 mb-10 max-w-2xl mx-auto">
                        Junta-te às empresas que já confiam no Logigate para gerir as suas operações.
                        Cria a tua conta em minutos e começa a trabalhar.
                    </p>

                    <div className="flex flex-wrap gap-4 justify-center">
                        <a
                            href="/criar"
                            className="inline-flex items-center gap-2 px-8 py-3.5 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl transition-colors text-lg"
                        >
                            Começar agora
                            <Icon icon="mdi:arrow-right" width={22} />
                        </a>
                        <a
                            href="#precos"
                            onClick={(e) => {
                                e.preventDefault();
                                document.querySelector("#precos")?.scrollIntoView({ behavior: "smooth" });
                            }}
                            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/10 hover:bg-white/15 text-white font-semibold rounded-xl border border-white/20 transition-colors text-lg"
                        >
                            Ver preços
                        </a>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
